import React from 'react';

import { planToIndex } from 'ggApp/modules/rentalPlan/helpers';
import { RentalPlanSelector as RentalPlanSelectorV2, RentalPlanSelectorPoint } from '@getgrover/ui';

import { Loader } from './styled';
import { RentalPlan } from '../../types';

const rentalPlanAccentColors = {
    backgroundColor: '#e6f4fe',
    textColor: '#068ef9',
};

interface RentalPlanSelectorProps {
    className: string;
    points: Array<RentalPlanSelectorPoint>;
    setRentalPlanIndex: (arg1: () => void) => void;
    rentalPlanIndex: number;
    selectedPlan: RentalPlan;
}

const RentalPlanSelector = ({
    className,
    rentalPlanIndex,
    points,
    selectedPlan,
    setRentalPlanIndex,
}: RentalPlanSelectorProps): JSX.Element | null => {
    const pointSelectHandler = (plan: RentalPlanSelectorPoint): void => {
        setRentalPlanIndex(planToIndex(points, plan));
    };

    const areMultiplePlans = points.length > 1;
    const isSinglePlanWithLongTerm = points.length === 1 && selectedPlan.minimumMonths !== 1;
    if (areMultiplePlans || isSinglePlanWithLongTerm) {
        const pointIndex = Math.min(points.length - 1, rentalPlanIndex);

        return (
            <RentalPlanSelectorV2
                className={className}
                defaultPointIndex={pointIndex}
                points={points}
                pointAccentColors={rentalPlanAccentColors}
                onPointSelected={pointSelectHandler}
                pointIndex={pointIndex}
                hasPlusLabel
                isDraggable
                isHoverable
            />
        );
    }

    return null;
};

export default RentalPlanSelector;
